<template>
  <span class="logout">
    <el-button size="small" @click="openResetDialog">修改密码</el-button>
    <el-button size="small" @click="logout">退出</el-button>
    <el-dialog
      title="修改密码"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-form ref="form" :model="resetData" label-width="80px">
        <el-form-item label="旧密码">
          <el-input v-model="resetData.old_pwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="resetData.new_pwd"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetPassword">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { managerLogout, managerRestPassword } from '@/api/manager'
import { staffLogout, staffRestPassword } from '@/api/staff'
import { mapGetters } from 'vuex'

export default {
  name: 'logout',
  components: {},
  data() {
    return {
      resetData: {
        old_pwd: '',
        new_pwd: '',
      },
      dialogVisible: false,
    }
  },
  computed: {
    ...mapGetters(['loginType']),
  },
  methods: {
    openResetDialog() {
      this.resetData = {
        old_pwd: '',
        new_pwd: '',
      }
      this.dialogVisible = true
    },
    async resetPassword() {
      let postData = { ...this.resetData }
      if (this.loginType == 'manager') {
        var { code, msg } = await managerRestPassword(postData)
      } else {
        var { code, msg } = await staffRestPassword(postData)
      }
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.dialogVisible = false
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
    logout() {
      console.log(this.loginType)
      if (this.loginType == 'manager') {
        this.logoutManager()
      } else {
        this.logoutStaff()
      }
    },
    async logoutManager() {
      let { code, msg } = await managerLogout()
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.$message({
          type: 'success',
          message: msg,
        })
        this.$store.dispatch('xLogout')
        this.$router.push({
          path: '/login/manager',
          query: { id: sessionStorage.getItem('companyId') },
        })
      }
    },
    async logoutStaff() {
      let { code, msg } = await staffLogout()
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.$message({
          type: 'success',
          message: msg,
        })
        this.$store.dispatch('xLogout')
        this.$router.push({
          path: '/login',
          query: { id: sessionStorage.getItem('companyId') },
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.logout {
  float: right;
  & > .el-button {
    vertical-align: middle;
  }
}
</style>
